import { Component, KeyboardEvent, MouseEvent } from "react";

const ACTION_CLICK_TIMEOUT = 500;

interface ActionProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  // FIXME adding a proper type results in a bunch of errors
  // that are non-obvious to fix - potential bugs
  onClick?: any;
  // FIXME some consumers expect us to support this property.
  // Which we don't...
  disabled?: boolean;
  // e2e markers (HTMLAttributes has no data-* index signature for custom components).
  "data-cy"?: string;
  "data-testid"?: string;
}

export default class Action extends Component<ActionProps> {
  private justClicked: boolean = false;

  private disallowClick = (): void => {
    this.justClicked = true;
    setTimeout(() => {
      this.justClicked = false;
    }, ACTION_CLICK_TIMEOUT);
  };

  private onClick = (evt: MouseEvent<HTMLAnchorElement>): boolean | void => {
    if (!this.justClicked) {
      this.disallowClick();
      this.props.onClick?.(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  };

  private onDoubleClick = (evt: MouseEvent<HTMLAnchorElement>): boolean | void => {
    if (!this.justClicked) {
      this.disallowClick();
      const clickHandler = this.props.onDoubleClick || this.props.onClick;
      clickHandler?.(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  };

  private onKeyDown = (evt: KeyboardEvent<HTMLAnchorElement>): void => {
    if (evt.key === "Enter" || evt.key === " ") {
      evt.preventDefault();
      this.onClick(evt as unknown as MouseEvent<HTMLAnchorElement>);
    }
    this.props.onKeyDown?.(evt);
  };

  render() {
    const { className, ...restProps } = this.props;
    // An <a> without href is excluded from the tab order — which made every
    // href-less Action (session-card Reschedule/Cancel, the header Tools tab,
    // ~170 more call sites) unreachable by keyboard. Href-less Actions act as
    // buttons, so they get button semantics; real links keep native behavior.
    const isButtonLike = this.props.href === undefined || this.props.href === null;
    const propsToPass = {
      ...restProps,
      onClick: this.onClick,
      onDoubleClick: this.onDoubleClick,
      className: className ?? "btn",
      ...(isButtonLike && {
        role: "button" as const,
        tabIndex: this.props.tabIndex ?? 0,
        onKeyDown: this.onKeyDown,
      }),
    };
    return <a {...propsToPass}>{this.props.children}</a>;
  }
}
